import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { parsePhoneNumber } from 'react-phone-number-input'
import Phone from 'react-phone-number-input'
import ValidationErrorMessage from '../shared/ValidationErrorMessage'
import 'react-phone-number-input/style.css'

export default class PhoneInput extends Component {
  static propTypes = {
    label: PropTypes.string.isRequired,
    placeholder: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    value: PropTypes.string,
    className: PropTypes.string,
    validator: PropTypes.func,
    handleChange: PropTypes.func,
    errorMessage: PropTypes.string
  }

  static defaultProps = {
    defaultClassNames: 'form-input field',
    validator: () => {},
    handleChange: () => {}
  }

  constructor (props) {
    super(props)
    const phoneNumber = props.value ? `+${props.value}` : ''

    this.state = {
      value: phoneNumber,
      errorMessage: props.errorMessage || (props.value && props.validator(props.value))
    }
  }

  handleChange (name, value) {
    const errorMessage = this.props.validator(value)
    this.setState({ errorMessage, value })
    this.props.handleChange(name, value)
  }

  composeClassNames () {
    const classNames = [
      this.props.defaultClassNames,
      this.props.className
    ]
    if (this.state.errorMessage) {
      classNames.push('has-error')
    };
    return classNames.join(' ')
  }

  getCountry (number) {
    const { country, _ } = parsePhoneNumber(`+${number}`) || {}
    return country || 'ZA'
  }

  render () {
    return (
      <div className={this.composeClassNames()}>
        <label htmlFor={this.props.name}>{this.props.label}</label>
        <Phone placeholder={this.props.placeholder}
          defaultCountry={this.getCountry(this.state.value)}
          value={this.state.value}
          name={this.props.name}
          onChange={val => this.handleChange(this.props.name, val)} />
        <ValidationErrorMessage errorMessage={this.state.errorMessage} />
      </div>
    )
  }
}
